export default function PHP_info() {
  return (
    <div>
      <h1>PHP_info</h1>
    </div>
  );
}
